import { MouseClickRightSvg } from "@lhd/assets";
import { IData } from "../hook";
import { toString } from "lodash";

export const useColumns = () => {
  return [
    {
      columnId: "index",
      label: "No.",
      type: "text",
      width: 30,
      editable: false,
      icon: <></>,
    },
    {
      label: "プロジェクト名",
      columnId: "name",
      width: 400,
      type: "text",
      icon: <></>,
    },
    {
      label: "顧客名",
      columnId: "client_name",
      width: 400,
      type: "text",
      icon: <MouseClickRightSvg />,
    },
    {
      label: "備考",
      columnId: "note",
      width: 600,
      type: "text",
      validator: (text: string) => false,
      icon: <></>,
    },
  ];
};

export const handleData = (data: IData[]) => {
  return [
    ...data,
    ...Array.from(
      Array(data.length > 1000 ? 0 : 1000 - data.length).keys(),
    ).map((_, index) => ({
      name: "",
      client_name: "",
      note: "",
    })),
  ];
};

export const checkInvalid = (
  data: IData,
  fields?: string[],
  countFieldValidate?: number,
) => {
  let result = false;
  let haveData = false;
  let countFieldInvalid = 0;
  if (fields) {
    fields.forEach((fieldItem) => {
      if (!data?.[fieldItem as keyof IData]) {
        result = true;
        countFieldInvalid = countFieldInvalid + 1;
      } else {
        haveData = true;
      }
    });
  } else {
    Object.keys(data).forEach((keyItem: string) => {
      if (!data?.[keyItem as keyof IData]) {
        result = true;
      } else {
        haveData = true;
      }
    });
  }
  return {
    invalid:
      countFieldValidate === undefined
        ? result
        : result && fields && countFieldInvalid === countFieldValidate,
    haveData,
  };
};

export const convertItem = (item: IData) => {
  return {
    ...item,
    client_name: item?.client ? item.client?.name : toString(item?.client_name),
  };
};
export const project_sheet_fields_convert_attr = ["client_name"];
